import React, { useEffect, useRef, useState } from "react";
import Scrollbar from "perfect-scrollbar";
import { Button } from "@ts-digital/vrc";
import { useSelector } from "react-redux";
import { FormattedMessage} from "react-intl";
import CompanyInfo from "./companyInfo";
import Frequency from "./frequency";
import Scope from "./scope";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  
  FixedAmountEngine,
  recurrenceRfcStringFromIsoPeriod
} from "@ts-digital/dbox-installments-engine";
import Type from "./type";
import Date from "./date";
import moment from "moment";
import Total from "./total";
import { useNavigate } from "react-router-dom";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./style.scss";
import ActualOrPlanned from "./actualOrPlanned";
import PaymentRadioState from "./paymentRadioState";
import DeadlinesPreview from "./deadlinesPreview";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import Payment from "./payment";
import Counterpart from "./counterpart";
import DocumentBrowsing from "../../general/DocumentBrowsing";
import Description from "./description";
import DeadlineChips from "./deadlineChips";

const engine = new FixedAmountEngine();

const AddDeadline = ({onConfirm}) => {  
  const navigate = useNavigate();
  const scrollerColRef1 = useRef();
  const scrollerColRef2 = useRef();

  const deadlinesCompany = useSelector((state) => state.deadlinesCompany);
  const main = useSelector(state => state.main);
  const accountantIdSelected = main.accountantIdSelected;
  const clientIdSelected = main.clientIdSelected;
  const accountantSelected = main.accountantSelected;
  const companySelected = main.companySelected;  
  
  const requestBodyDefault = {
    counterpart: {
      description: "",
      taxId: "",
      vatNumber: ""
    },
    itemId: clientIdSelected,
    managerId: accountantIdSelected,
    scope: "",
    type: "", // TODO capire dove inserire nel mockup manca
    description: {
      title: "",
      details: ""
    },
    status: {
      confirmed: true
    },
    date: undefined,
    attachments: [],
    totalAmount: undefined,
    payment: {
      type: "",
      status: "due",
      compensation: false,
      mode: {}
    }
  };
    
  const [frequencyDates, setFrequencyDates] = useState({
    startDate: null,
    endDate: null
  });
  const [frequencyType, setFrequencyType] = useState("single");
  const [frequencyVal, setFrequencyVal] = useState("P1W");
  const [isSave, setIsSave] = useState(false);
  const [requestBody, setRequestBody] = useState(requestBodyDefault);
  const [deadlinesToShow, setDeadlinesToShow] = useState([]);
  const [documents, setDocuments] = useState([]);

  const addDocument = document => {
    let newdocs = { ...documents };
    let newdocsid = [];
    if (!newdocs[document.documentId]) {
      newdocs[document.documentId] = document;
    }
    for (let item in newdocs) {
      if (newdocs.hasOwnProperty(item)) {
        newdocsid.push({
          appId: "DBX",
          featureCode: "CORE",
          id: item
        });
      }
    }
    setDocuments(newdocs);
    setRequestBody({
      ...requestBody,
      attachments: newdocsid
    });
  };
  
  const checkAndSend = () => {    
    /** invia in create solo se tutti i campi obbligatori sono compilati */
    if (!requestBody.scope) return;
    if (["fiscal_social_security", "studio_reminder"].includes(requestBody.scope) && !requestBody.type) return;
    if ((frequencyType === "single" && !requestBody.date) || 
    (frequencyType === "recurring" && 
      (!frequencyDates.startDate || !frequencyDates.endDate))) return;
    if (requestBody.status.confirmed && !requestBody.totalAmount) return;
    if (requestBody.scope !== "fiscal_social_security" && (!requestBody?.counterpart?.description || !requestBody?.counterpart?.taxId || !requestBody?.counterpart?.vatNumber)) return;
    if (requestBody.status.confirmed && ((!["rent", "credit", "debt", "financing", "recurring_fees"].includes(requestBody.scope) &&  !requestBody.payment.type) || !requestBody?.payment?.mode?.id)) return;
    if (requestBody.status.confirmed && requestBody.payment.status === "paid" && !requestBody?.payment?.execution?.date) return; 
    if (!requestBody?.description?.title) return;
    onConfirm(requestBody);
  };

  const getDeadlinesPreview = () => {
    const newArray = [];
    const deadlines = engine.calculateByIsoPeriod(
      moment(frequencyDates.startDate).toDate(),
      moment(frequencyDates.endDate).toDate(),
      frequencyVal,
      requestBody.totalAmount
    );
    deadlines.map((itm, index) => {
      newArray.push({
        //  ...itm,
        key: index + 1,
        index: index + 1,
        date: moment(`${itm.date}`).format(DATE_FORMAT_FOR_DISPLAY),        
        amount: requestBody.totalAmount ? new Intl.NumberFormat("it-IT", {
          style: "decimal",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(parseFloat(requestBody.totalAmount)) + " €" : "0 €"
      });
      return newArray;
    });
    setDeadlinesToShow(newArray);
  };
  
  useEffect(() => {
    setRequestBody({
      ...requestBody,
      scope: undefined
    });
  }, [frequencyType]);
  
  useEffect(() => {
    if (!scrollerColRef1.current) return undefined;
    let ps = new Scrollbar(scrollerColRef1.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [scrollerColRef1?.current]);

  useEffect(() => {
    if (!scrollerColRef2.current) return undefined;
    let ps = new Scrollbar(scrollerColRef2.current);
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [scrollerColRef2?.current]);
  
  useEffect(() => {    
    // setto a false l'isSave se cambia qualche parametro per evitare segnalazioni errori
    setIsSave(false);
  }, [requestBody]);

  useEffect(() => {
    // In caso di ricorrenza della scadenza    
    if (!frequencyDates.startDate || !frequencyDates.endDate || !frequencyVal) return;

    const reccurrenceString = recurrenceRfcStringFromIsoPeriod(
      moment(frequencyDates.startDate).toDate(),
      moment(frequencyDates.endDate).toDate(),
      frequencyVal
    );

    setRequestBody({
      ...requestBody,
      recurrence: reccurrenceString
    });

    if (frequencyDates.startDate && frequencyDates.endDate){
      getDeadlinesPreview();
    }
    
  }, [frequencyDates, frequencyVal, requestBody?.totalAmount]);

  return (
    <>
      <div className="Add-deadline-root">
        <div className="add-deadline-row">
          <div className="add-deadline-column" ref={scrollerColRef1}>
            <CompanyInfo />
            <div style={{marginTop: "48px"}}>
              <Frequency frequencyType={frequencyType} setFrequencyType={setFrequencyType} />
            </div>
            <div style={{marginTop: "48px"}}>
              <Scope                 
                frequencyType={frequencyType}
                isReconciliationForm={false} 
                isSave={isSave}
                requestBody={requestBody}                 
                setRequestBody={setRequestBody}
              />              
            </div>
            { ["fiscal_social_security", "studio_reminder"].includes(requestBody.scope) &&
              <div style={{marginTop: "48px"}}>
                <Type isSave={isSave} requestBody={requestBody} setRequestBody={setRequestBody} />
              </div>
            }
          </div>
          <div className="add-deadline-column" ref={scrollerColRef2}>
            <div className="doubleCols">
              <Date 
                frequencyDates={frequencyDates} 
                setFrequencyDates={setFrequencyDates}
                frequencyType={frequencyType} 
                isSave={isSave} 
                requestBody={requestBody}                 
                setRequestBody={setRequestBody}
              />                          
              <Total isReconciliationForm={false} isSave={isSave} requestBody={requestBody} 
                setRequestBody={setRequestBody} />              
            </div>  
            <div className="doubleCols">              
              <ActualOrPlanned isReconciliationForm={false} requestBody={requestBody}                 
                setRequestBody={setRequestBody} />   
              <PaymentRadioState 
                isReconciliationForm={false} requestBody={requestBody}                 
                setRequestBody={setRequestBody} />                           
            </div>
            <div>                             
              <DeadlinesPreview
                frequencyType={frequencyType}
                frequencyVal={frequencyVal}
                deadlinesToShow={deadlinesToShow}
                requestBody={requestBody}
                onChange={(val, freq) => {
                  setRequestBody(val);
                  setFrequencyVal(freq);
                }}
              />              
            </div>
            <div>  
              <Payment isSave={isSave} requestBody={requestBody} 
                setRequestBody={setRequestBody} />
            </div>
            <div>
              <Counterpart isSave={isSave} requestBody={requestBody} setRequestBody={setRequestBody} />
            </div>

            <div style={{ margin: "64px 72px 0 0" }}>
              <div className="add-deadline-section">
                <FormattedMessage id="deadlines.pages.create.details" />
              </div>
              <Description
                isSave={isSave}
                isReconciliationForm={false}               
                onChange={e => {
                  setRequestBody({
                    ...requestBody,
                    description: {
                      title: e.target.value
                    }
                  });                  
                }}
                requestBody={requestBody}
              />
              {(requestBody.status.confirmed === true || requestBody.scope !== "fiscal_social_security") &&
                <div
                  style={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  <DocumentBrowsing
                    id={"AddDeadlineDocBrowsing"}
                    accountantSelected={accountantSelected}
                    accountantIdSelected={accountantIdSelected}
                    companySelected={companySelected}
                    clientIdSelected={clientIdSelected}
                    addDocument={addDocument}
                    selected={documents}
                  />
                </div>
              }
              {
                <DeadlineChips
                  documents={documents}
                  onRemoveDocument={docId => removeDocument(docId)}
                />
              }
            </div>

          </div>
        </div>
      </div>
      <div className="Deadlines-nuovo-bottomBar" style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end"
      }}>
        {deadlinesCompany?.createDeadline?.status?.started ? 
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ color: "#0090d1" }}
          />
          :                  
          <>
            <Button kind="tertiary" onClick={() => navigate("/scadenze")}>
              <FormattedMessage id="actions.cancel" />
            </Button>
            <Button className="gs-deadlines-add" onClick={() => {                
              setIsSave(true);
              checkAndSend();              
            }}>
              <FormattedMessage id="deadlines.pages.create.save" />
            </Button>
          </>
          
        }
      </div>
          
    </>
  );
};

export default AddDeadline;